import { useEffect, useState } from "react";
import AccessControl from "../functional/AccessControl";
import CreateRecordButton from "../input/CreateRecordButton";
import BasicCrudScreenType from "../screenTypes/functional/BasicCrudScreenType";
import BasicCrudScreenActionItemLayout from "../screenTypes/layout/BasicCrudScreenActionItemLayout";
import getSchema from "../../lib/api/getSchema";
import notificationState from "../../states/notificationState";
import { useSetRecoilState } from "recoil";

function AutoCodeTest ( props ) {

    const table = "AutoCodeTest";

    const setNotification = useSetRecoilState(notificationState);

    const [schema, setSchema] = useState();
    const [api, setApi] = useState();

    useEffect(() => {
        let mounted = true;

        (async () => {
            let schema = await getSchema(table);

            if (mounted) {

                setSchema(schema);
            }
        })();

        return () => {
            mounted = false;
        };
    }, []);

    const notifySuccess = (msg) => {
        setNotification({
            severity: "success",
            msg: msg,
            open: true,
        });
    };

    const onSuccess = (msg) => {

        notifySuccess(msg);

    };

    const onApiInitialized = (api) => {

        setApi(api);

    }

    const customizeErrorMsgCallback = (reason) => {

        // reason.response := { data, status, statusText, headers, config, request }
        // data : user error message
        // status : http status code
        // statusText : http status code text
        const response = reason.response;
        return `${response.data} `;

    }

    const onAppendButtonAtFirst = () => {

        return (
            <>
                <BasicCrudScreenActionItemLayout>

                    <AccessControl accessTarget={schema && schema.name} accessMethod="POST">
                        <CreateRecordButton
                            id={table}
                            schema={schema}
                            refresh={api}
                            onSuccess={onSuccess}
                            customizeErrorMsgCallback={customizeErrorMsgCallback}

                        />
                    </AccessControl>

                </BasicCrudScreenActionItemLayout>
            </>
        )

    }

    return ( 
        <BasicCrudScreenType 
            id={table}
            table={table}
            view={table}
            noCreate
            noExcel
            onApiInitialized={onApiInitialized}
            onAppendButtonAtFirst={onAppendButtonAtFirst}
        />
    );

}

export default AutoCodeTest;
